import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UiAtomButtonComponent } from '@shared/components/atoms/ui-atom-button/ui-atom-button.component';

@Component({
  selector: 'ui-organism-footer-info-dialog',
  standalone: true,
  imports: [MatDialogModule, UiAtomButtonComponent],
  // El contenido de .footer-info-dialog__content llega vía [innerHTML] (fuera del compilador de Angular),
  // así que necesita encapsulación None para que las reglas de abajo le lleguen.
  encapsulation: ViewEncapsulation.None,
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <div class="footer-info-dialog__content" [innerHTML]="data.message"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <ui-atom-button
        [text]="data.closeText"
        styling="text"
        rules="main"
        (buttonClick)="dialogRef.close()"
      >
      </ui-atom-button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .footer-info-dialog__content {
        text-align: left;

        h3 {
          margin: 1.25rem 0 0.5rem;
          font-size: 1rem;
          font-weight: bold;
          text-decoration: underline;

          &:first-child {
            margin-top: 0;
          }
        }

        p {
          margin: 0 0 0.75rem;
        }

        ul {
          margin: 0 0 0.75rem;
          padding-left: 1.25rem;
        }

        li {
          margin-bottom: 0.25rem;
        }
      }
    `,
  ],
})
export class FooterInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FooterInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; closeText: string },
  ) {}
}

@Component({
  selector: 'ui-organism-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './ui-organism-footer.component.html',
  styleUrl: './ui-organism-footer.component.scss',
})
export class UiOrganismFooterComponent {
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  private openInfoDialog(titleKey: string, messageKey: string, size: 'dialog-lg' | 'dialog-xl' = 'dialog-lg'): void {
    this.dialog.open(FooterInfoDialogComponent, {
      width: '90vw',
      maxWidth: size === 'dialog-xl' ? '1200px' : '1000px',
      minHeight: '300px',
      maxHeight: '90vh',
      panelClass: [size, 'dialog-safe-area'],
      autoFocus: false,
      data: {
        title: this.translate.instant(titleKey),
        message: this.translate.instant(messageKey),
        closeText: this.translate.instant('buttons.close'),
      },
    });
  }

  openPrivacyPolicyDialog(): void {
    this.openInfoDialog('footer.dialog.privacy.title', 'footer.dialog.privacy.message', 'dialog-xl');
  }

  openLegalNoticeDialog(): void {
    this.openInfoDialog('footer.dialog.legal.title', 'footer.dialog.legal.message');
  }

  openTermsAndConditionsDialog(): void {
    this.openInfoDialog('footer.dialog.terms.title', 'footer.dialog.terms.message');
  }
}
